export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_616567c5-e158-4566-a9d7-19246c01b371/artifacts/v0ibayg1_Junk%20removal%20logo%20%285%29.png";

export const FOUNDER_IMAGE =
  "https://customer-assets.emergentagent.com/job_616567c5-e158-4566-a9d7-19246c01b371/artifacts/7j1ajsm1_rs%3Dw_671%2Ch_895.webp";

export const TEA_PARTY_COVER =
  "https://customer-assets.emergentagent.com/job_hosea-new-vision/artifacts/bmarjy9v_pexels-csbstudioza-34788172.jpg";

export const ABOUT_GAP_IMAGE =
  "https://customer-assets.emergentagent.com/job_hosea-new-vision/artifacts/pjfroo4w_rs%3Dw_1200%2Ccg_true.webp";

export const ORG = {
  name: "Hosea Ministries Foundation",
  tagline: "Christ-Centered Supportive & Transitional Living",
  mission:
    "Our mission is to provide assistance and support for women who have been incarcerated or are recovering from substance abuse in transition to healthier lives through health, wellness, and education.",
  address: "809 N. Vinita Ave A, Tahlequah, OK 74464",
  phone: "(918) 316-5889",
  phoneTel: "19183165889",
  email: "Info@hoseaministriesfoundation.org",
  hours: "Mon–Fri · 9:00 AM – 5:00 PM",
  donateUrl: "https://donorbox.org/seed-money-for-hosea-ministries-foundation",
  rsvpUrl: "https://www.eventbrite.com/e/1987277247744?aff=oddtdtcreator",
  facebookUrl: "https://www.facebook.com/HoseaMinistriesFoundation",
  founder: {
    name: "Nikki Hendricks",
    title: "Founder",
  },
  secondaryContact: {
    name: "John Downs",
    phone: "(405) 625-6456",
    phoneTel: "14056256456",
  },
  fees: { entry: 100, weekly: 125 },
};

// Tea Party event – active until May 2, 2026 (end of day local)
export const TEA_PARTY = {
  title: "Spring Tea Party",
  dateLabel: "May 2, 2026",
  time: "1:00 PM – 3:00 PM",
  host: "Generations Church",
  description:
    "Join us for a beautiful afternoon at the Hosea Ministries Foundation Spring Tea. Enjoy fellowship, refreshments, and a time to connect while supporting a meaningful cause.",
  rsvpUrl: "https://www.eventbrite.com/e/1987277247744?aff=oddtdtcreator",
  // Hide after midnight on May 3, 2026 local time
  hideAfter: new Date("2026-05-03T00:00:00").getTime(),
};

export const isTeaPartyActive = () => Date.now() < TEA_PARTY.hideAfter;
